var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("text-input", {
        attrs: {
          id: "pLidNaam",
          label: _vm.labels.naam,
          "is-dirty": _vm.personeelslid.naam != _vm.cache.naam,
          "validation-object": _vm.$v.personeelslid.naam,
          "is-disabled": _vm.disabledFieldsMap.naam,
          info: _vm.infoForInput("naam")
        },
        model: {
          value: _vm.$v.personeelslid.naam.$model,
          callback: function($$v) {
            _vm.$set(
              _vm.$v.personeelslid.naam,
              "$model",
              typeof $$v === "string" ? $$v.trim() : $$v
            )
          },
          expression: "$v.personeelslid.naam.$model"
        }
      }),
      _vm._v(" "),
      _c("text-input", {
        attrs: {
          id: "pLidVoornaam",
          label: _vm.labels.voornaam,
          "is-dirty": _vm.personeelslid.voornaam != _vm.cache.voornaam,
          "validation-object": _vm.$v.personeelslid.voornaam,
          "is-disabled": _vm.disabledFieldsMap.voornaam,
          info: _vm.infoForInput("voornaam")
        },
        model: {
          value: _vm.$v.personeelslid.voornaam.$model,
          callback: function($$v) {
            _vm.$set(_vm.$v.personeelslid.voornaam, "$model", $$v)
          },
          expression: "$v.personeelslid.voornaam.$model"
        }
      }),
      _vm._v(" "),
      _c("text-input", {
        attrs: {
          id: "pLidVoornaam2",
          label: _vm.labels.voornaam2,
          "is-dirty": _vm.personeelslid.voornaam2 != _vm.cache.voornaam2,
          "validation-object": _vm.$v.personeelslid.voornaam2,
          "is-disabled": _vm.disabledFieldsMap.voornaam2,
          info: _vm.infoForInput("voornaam2")
        },
        model: {
          value: _vm.$v.personeelslid.voornaam2.$model,
          callback: function($$v) {
            _vm.$set(_vm.$v.personeelslid.voornaam2, "$model", $$v)
          },
          expression: "$v.personeelslid.voornaam2.$model"
        }
      }),
      _vm._v(" "),
      _c("text-input", {
        attrs: {
          id: "pLidRoepnaam",
          label: _vm.labels.roepnaam,
          "is-dirty": _vm.personeelslid.roepnaam != _vm.cache.roepnaam,
          "validation-object": _vm.$v.personeelslid.roepnaam,
          "is-disabled": _vm.disabledFieldsMap.roepnaam,
          info: _vm.infoForInput("roepnaam"),
          inputRemark: _vm.warningFieldsMap.roepnaam
        },
        model: {
          value: _vm.$v.personeelslid.roepnaam.$model,
          callback: function($$v) {
            _vm.$set(_vm.$v.personeelslid.roepnaam, "$model", $$v)
          },
          expression: "$v.personeelslid.roepnaam.$model"
        }
      }),
      _vm._v(" "),
      !_vm.hiddenFieldsMap.initialen
        ? _c("text-input", {
            attrs: {
              id: "pLidInitialen",
              label: _vm.labels.initialen,
              "is-dirty": false,
              "validation-object": _vm.$v.personeelslid.initialen,
              "is-disabled": _vm.disabledFieldsMap.initialen,
              info: _vm.infoForInput("initialen")
            },
            model: {
              value: _vm.personeelslid.initialen,
              callback: function($$v) {
                _vm.$set(_vm.personeelslid, "initialen", $$v)
              },
              expression: "personeelslid.initialen"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("gender-input", {
        attrs: {
          id: "pLidGeslacht",
          label: _vm.labels.geslacht,
          "is-disabled": _vm.disabledFieldsMap.geslacht,
          info: _vm.infoForInput("geslacht"),
          "is-dirty": _vm.personeelslid.geslacht.trim() != _vm.cache.geslacht
        },
        model: {
          value: _vm.$v.personeelslid.geslacht.$model,
          callback: function($$v) {
            _vm.$set(_vm.$v.personeelslid.geslacht, "$model", $$v)
          },
          expression: "$v.personeelslid.geslacht.$model"
        }
      }),
      _vm._v(" "),
      _c("date-input", {
        attrs: {
          required: _vm.$v.personeelslid.geboortedatum.hasOwnProperty(
            "required"
          ),
          id: "pLidGeboortedatum",
          label: _vm.labels.geboortedatum,
          "is-dirty":
            _vm.personeelslid.geboortedatum != _vm.cache.geboortedatum,
          "is-disabled": _vm.disabledFieldsMap.geboortedatum,
          info: _vm.infoForInput("geboortedatum"),
          "is-invalid": _vm.$v.personeelslid.geboortedatum.$invalid
        },
        model: {
          value: _vm.$v.personeelslid.geboortedatum.$model,
          callback: function($$v) {
            _vm.$set(_vm.$v.personeelslid.geboortedatum, "$model", $$v)
          },
          expression: "$v.personeelslid.geboortedatum.$model"
        }
      }),
      _vm._v(" "),
      _vm.personeelslid.geboorteland.land == "België"
        ? _c("city-input", {
            attrs: {
              id: "pLidGeboorteplaats",
              label: _vm.labels.geboorteplaats,
              placeholder: "Stad",
              "is-disabled": _vm.disabledFieldsMap.geboorteplaats,
              info: _vm.infoForInput("geboorteplaats"),
              "is-dirty":
                _vm.personeelslid.geboorteplaats != _vm.cache.geboorteplaats,
              required: _vm.$v.personeelslid.geboorteplaats.hasOwnProperty(
                "required"
              )
            },
            model: {
              value: _vm.$v.personeelslid.geboorteplaats.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.personeelslid.geboorteplaats, "$model", $$v)
              },
              expression: "$v.personeelslid.geboorteplaats.$model"
            }
          })
        : _c("text-input", {
            attrs: {
              id: "pLidGeboorteplaats",
              label: _vm.labels.geboorteplaats,
              "is-disabled": _vm.disabledFieldsMap.geboorteplaats,
              info: _vm.infoForInput("geboorteplaats"),
              "is-dirty":
                _vm.personeelslid.geboorteplaats != _vm.cache.geboorteplaats,
              "validation-object": _vm.$v.personeelslid.geboorteplaats
            },
            model: {
              value: _vm.$v.personeelslid.geboorteplaats.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.personeelslid.geboorteplaats, "$model", $$v)
              },
              expression: "$v.personeelslid.geboorteplaats.$model"
            }
          }),
      _vm._v(" "),
      _c("country-input", {
        attrs: {
          id: "pLidGeboorteland",
          label: _vm.labels.geboorteland,
          "is-disabled": _vm.disabledFieldsMap.geboorteland,
          info: _vm.infoForInput("geboorteland"),
          placeholder: "Land",
          "is-dirty":
            _vm.personeelslid.geboorteland.land != _vm.cache.geboorteland.land
        },
        model: {
          value: _vm.$v.personeelslid.geboorteland.$model,
          callback: function($$v) {
            _vm.$set(_vm.$v.personeelslid.geboorteland, "$model", $$v)
          },
          expression: "$v.personeelslid.geboorteland.$model"
        }
      }),
      _vm._v(" "),
      _c("yes-no-input", {
        attrs: {
          name: "persMindervalideYesNo",
          id: "pLidEditingMindervalide",
          label: _vm.labels.persMindervalide,
          "is-disabled": _vm.disabledFieldsMap.persMindervalide,
          "is-dirty":
            _vm.personeelslid.persMindervalide != _vm.cache.persMindervalide
        },
        model: {
          value: _vm.personeelslid.persMindervalide,
          callback: function($$v) {
            _vm.$set(_vm.personeelslid, "persMindervalide", $$v)
          },
          expression: "personeelslid.persMindervalide"
        }
      }),
      _vm._v(" "),
      _c("text-input", {
        attrs: {
          id: "pLidInszNr",
          label: _vm.labels.inszNr,
          "is-dirty": _vm.personeelslid.inszNr != _vm.cache.inszNr,
          "validation-object": _vm.$v.personeelslid.inszNr,
          "is-disabled": _vm.disabledFieldsMap.inszNr,
          info: _vm.infoForInput("inszNr")
        },
        model: {
          value: _vm.$v.personeelslid.inszNr.$model,
          callback: function($$v) {
            _vm.$set(_vm.$v.personeelslid.inszNr, "$model", $$v)
          },
          expression: "$v.personeelslid.inszNr.$model"
        }
      }),
      _vm._v(" "),
      _c("text-input", {
        attrs: {
          id: "pLidStamnummer",
          label: _vm.labels.stamnummer,
          "validation-object": _vm.$v.personeelslid.stamnummer,
          "is-dirty": false,
          "is-disabled": _vm.disabledFieldsMap.stamnummer,
          info: _vm.infoForInput("stamnummer")
        },
        model: {
          value: _vm.$v.personeelslid.stamnummer.$model,
          callback: function($$v) {
            _vm.$set(_vm.$v.personeelslid.stamnummer, "$model", $$v)
          },
          expression: "$v.personeelslid.stamnummer.$model"
        }
      }),
      _vm._v(" "),
      _vm.personeelslid.contrStamnummer
        ? _c("text-input", {
            attrs: {
              "validation-object": _vm.$v.personeelslid.contrStamnummer,
              id: "pLidContrStamnummer",
              label: _vm.labels.contrStamnummer,
              "is-dirty": false,
              "is-disabled": _vm.disabledFieldsMap.contrStamnummer,
              info: _vm.infoForInput("contrStamnummer")
            },
            model: {
              value: _vm.$v.personeelslid.contrStamnummer.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.personeelslid.contrStamnummer, "$model", $$v)
              },
              expression: "$v.personeelslid.contrStamnummer.$model"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.hiddenFieldsMap.werknemerscode
        ? _c("text-input", {
            attrs: {
              id: "pLidwerknemerscode",
              label: _vm.labels.werknemerscode,
              "validation-object": _vm.$v.personeelslid.werknemerscode,
              "is-dirty": false,
              "is-disabled": _vm.disabledFieldsMap.werknemerscode,
              info: _vm.infoForInput("werknemerscode")
            },
            model: {
              value: _vm.$v.personeelslid.werknemerscode.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.personeelslid.werknemerscode, "$model", $$v)
              },
              expression: "$v.personeelslid.werknemerscode.$model"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.$v.personeelslid.natio.$each.$iter, function(v, index) {
        return _c("nationality-input", {
          key: index,
          attrs: {
            "is-disabled": _vm.disabledFieldsMap.natio,
            id: "a-" + index,
            label:
              _vm.personeelslid.natio.length != 1
                ? _vm.labels.natio.nationaliteit + " " + (parseInt(index) + 1)
                : _vm.labels.natio.nationaliteit,
            "is-dirty-natio": _vm.isDiffToCache(
              _vm.personeelslid.natio[parseInt(index)],
              _vm.cache.natio[parseInt(index)]
            ),
            "is-new": parseInt(index, 10) >= _vm.cache.natio.length,
            "show-delete": index != 0,
            info: _vm.infoForInput("natio")
          },
          on: {
            "delete-natio": function($event) {
              _vm.deleteNationality(parseInt(index))
            }
          },
          model: {
            value: _vm.personeelslid.natio[parseInt(index)],
            callback: function($$v) {
              _vm.$set(_vm.personeelslid.natio, parseInt(index), $$v)
            },
            expression: "personeelslid.natio[parseInt(index)]"
          }
        })
      }),
      _vm._v(" "),
      !_vm.disabledFieldsMap.natio
        ? _c(
            "div",
            { staticClass: "text-center mt-2" },
            [
              _c("plus-button", {
                attrs: {
                  disabled: _vm.disabledFieldsMap.natio,
                  label: "Nationaliteit toevoegen"
                },
                on: {
                  click: function($event) {
                    return _vm.addNationality()
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "pt-2 mt-3 border-top" }, [
        _c("label", { staticClass: "font-weight-bold" }, [
          _vm._v("Opmerking:")
        ]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.currentRemark,
              expression: "currentRemark"
            }
          ],
          staticClass: "form-control mb-2",
          attrs: { rows: "3", placeholder: "Opmerking", type: "text" },
          domProps: { value: _vm.currentRemark },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.currentRemark = $event.target.value
              },
              _vm.onRemarkChange
            ]
          }
        })
      ]),
      _vm._v(" "),
      _c("file-upload", {
        attrs: { label: "Bewijsstuk(ken) uploaden:", "upload-percentage": 0 },
        on: { "files-changed": _vm.onFilesChanged }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }